import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
//*MUI
import { Box, Modal } from "@mui/material";
//*files
import cssClasses from "./AssignBenefitPlanCP.module.css";
import Close from "../../Components/Icons/Close";
//subComponent
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import DropDown from "../../Subcomponents/DropDown";
import { Card } from "@mui/material";
//

import { useSelector } from "react-redux";
//service

import { dismissLoader, presentLoader } from "../../Services/loader";
import { getBenefitPlans } from "../../Services/BenefitPlans";
import { updateCPBenefitPlan } from "../../Services/ChannelPartner";

const useStyles = makeStyles((theme) => ({
  tokenName: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "2rem",
    lineHeight: "3rem",
    color: "#000000",
  },
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelCard: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelValue: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  backArrow: {
    verticalAlign: "middle",
  },
}));

export default function AssignBenefitPlanCP({
  open,
  handleClose,
  returnResp,
  data,
  showSuccess,
}) {
  const classes = useStyles();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(data);
  const [allPlan, setAllPlan] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState("");
  const [helperText,setHelperText]=useState('');
  useEffect(() => {
    getBenefitPlans()
      .then((resp) => {
        console.log(resp.data);
        setAllPlan([...resp.data]);
      })
      .catch((err) => {
        console.log(err);
      });
      if(data?.benefitPlanId!==null){
        setSelectedPlan(data?.benefitPlanId);
      }
  }, []);

  function closeModal() {
    handleClose();
  }

  function save(){
    //Update query 
    if(selectedPlan!==""){
      updateCPBenefitPlan(selectedPlan,data.cpId).then((resp)=>{
        console.log(resp);
        returnResp(true);
        showSuccess("Plan updated successfully");
        closeModal();
       
    }).catch((err)=>{
        console.log(err);
    });
    }else{
      setHelperText('Please select Plan');
    }
    
  }
  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperHeader}>
          <span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
            <Close width={"1.2rem"} height={"1.2rem"} />
          </span>
          <div>Benefit Plan</div>
        </div>
        <div className={cssClasses.wrapperContent}>
          <div className={cssClasses.wrapperBlock}>
            <div className={cssClasses.blockLabel}>
              Select Plan<span style={{ color: "red" }}> *</span>
            </div>
            <div style={{ width: "100%" }}>
              <DropDown
                list={allPlan.map((element, id) => {
                  return {
                    label: element.planName,
                    value: element.benefitPlanId,
                  };
                })}
                selectedValue={selectedPlan}
                onChangeSelect={(value) => {
                  setSelectedPlan(value);
                  setHelperText('');
                }}
                placeHolder={"Select"}
                //style.color is placeHolder's color
                style={{
                  background: "#F2F4F7",
                  color: "rgb(102, 112, 133)",
                }}
                helperText={helperText}
              />
            </div>
          </div>
        </div>
        <div className={cssClasses.wrapperFooter}>
          <div>
            <Button
              style={{
                color: "#344054",
                backgroundColor: "#ffffff",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={"Cancel"}
              clicked={() => {closeModal()}}
            />
          </div>
          <div>
            <Button
              style={{
                color: "#ffffff",
                backgroundColor: "#155EEF",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={"Update"}
              clicked={() => {
                save();
              }}
              disable={data?.cpId?.benefitPlanId === selectedPlan}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}
